export const TWO_HOP_ALIGNMENT_SCREEN_INDEXES = {
  PIVOT_SELECTION: 0,
  PIVOT_DETAILS: 1,
  POD_CREATION_ONE: 2,
  POD_CREATION_TWO: 3,
  SETTINGS: 4,
  ADVANCED_SETTINGS: 5
};
